"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _redux = require("redux");

var _reactRedux = require("react-redux");

var _campaignCreator = require("../../actions/campaignCreator");

var _PersonaFilters = _interopRequireDefault(require("../../components/PersonaFilters"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var CampaignPersonaFilters = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(CampaignPersonaFilters, _React$Component);

  function CampaignPersonaFilters() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = CampaignPersonaFilters.prototype;

  _proto.render = function render() {
    var themesFor = this.props.themesFor;
    var categories, setTheme, setShareOfAudience, setShareOfAttribute, setIndex, setPopulation;

    if (themesFor === 'media') {
      categories = this.props.mediaCategories;
      setTheme = this.props.setMediaTheme;
      setShareOfAudience = this.props.setMediaShareOfAudience;
      setShareOfAttribute = this.props.setMediaShareOfAttribute;
      setIndex = this.props.setMediaIndex;
      setPopulation = this.props.setMediaPopulation;
    } else {
      categories = this.props.categories;
      setTheme = this.props.setTheme;
      setShareOfAudience = this.props.setShareOfAudience;
      setShareOfAttribute = this.props.setShareOfAttribute;
      setIndex = this.props.setIndex;
      setPopulation = this.props.setPopulation;
    }

    return /*#__PURE__*/_react["default"].createElement(_PersonaFilters["default"], _extends({}, this.props, {
      categories: categories,
      setTheme: setTheme,
      setShareOfAudience: setShareOfAudience,
      setShareOfAttribute: setShareOfAttribute,
      setIndex: setIndex,
      setPopulation: setPopulation
    }));
  };

  return CampaignPersonaFilters;
}(_react["default"].Component);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    themeReset: state.themeFilter.reset,
    isFetchingCategories: state.categories.isFetching,
    categories: state.categories.categories,
    mediaCategories: state.categories.mediaCategories
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    setShareOfAttribute: _campaignCreator.setShareOfAttribute,
    setMediaShareOfAttribute: _campaignCreator.setMediaShareOfAttribute,
    setShareOfAudience: _campaignCreator.setShareOfAudience,
    setMediaShareOfAudience: _campaignCreator.setMediaShareOfAudience,
    setIndex: _campaignCreator.setIndex,
    setMediaIndex: _campaignCreator.setMediaIndex,
    setPopulation: _campaignCreator.setPopulation,
    setMediaPopulation: _campaignCreator.setMediaPopulation,
    setTheme: _campaignCreator.setTheme,
    setMediaTheme: _campaignCreator.setMediaTheme
  }, dispatch);
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CampaignPersonaFilters);

exports["default"] = _default;